<template>
    <b-row>
        <b-col cols="3">
            <div class="pr-5">
                <h2>API Access</h2>
                <p>Review your access to Riskhub API</p>
                <hr class="my-5">
            </div>
        </b-col>
        <b-col cols="9">
            <div class="border rounded bg-secondary px-3 py-3">
                <h5 class="font-weight-bold">Your API Token</h5>
                <hr class="my-3">
                <p>Your current token:</p>
                <div class="bg-grey">
                    <pre class="p-3">{{ token }}</pre>
                </div>
                <p v-if="expired">This token has expired. Please obtain a new API Token.</p>
                <p v-else-if="expiresIn">This token will expire: {{ expiresIn | readableDate }}</p>

                <p class="small my-2">
                    Obtaining a new token invalidates your previous token.
                </p>
                <b-btn variant="primary" @click="getApiToken">
                    <vue-element-loading :active="loading"></vue-element-loading>
                    Obtain API Token
                </b-btn>

            </div>

            <div class="border rounded bg-secondary px-3 py-3 mt-3">
                <h5 class="font-weight-bold">Your API Permissions</h5>
                <hr class="my-3">

                <b-row>
                    <b-col cols="3"
                           v-for="(permissions, section) in groupedPermissions"
                    >
                        <b-card
                                :header="section"
                                class="text-capitalize">
                            <b-list-group>
                                <b-list-group-item class="small"
                                                   v-for="permission in permissions">
                                    {{ permission.name | capitalise }}
                                </b-list-group-item>
                            </b-list-group>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { groupBy } from 'lodash';
import dayjs from 'dayjs';
import riskhub from "@/services/Riskhub/Riskhub";

export default {
  name: 'Api-Access',
  data() {
    return {
      expired: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters({ user: 'authUser', token: 'apiToken', expiresIn: 'apiExpiry' }),
    groupedPermissions() {
      const { roles }  = this.user;
      const allPermissions = [];
      roles.forEach((role) => {
        allPermissions.push(...role.permissions);
      });

      return groupBy(allPermissions, 'section');
    }
  },
  filters: {
    readableDate(date) {
      return riskhub.formatDateTime(date);
    },
  },
  watch: {
    expiresIn: {
      handler(newExpiresIn) {
        if (newExpiresIn) {
          this.expired = dayjs(newExpiresIn).isBefore(dayjs());
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['refreshApiToken']),
    async getApiToken() {
      this.loading = true;
      try {
        await this.refreshApiToken();
        this.$notify({
          title: 'API Token updated',
          type: 'success',
        });
      } catch (e) {
        this.$notify({
          title: 'Could not obtain new API Token',
          text: 'Please try again later',
          type: 'error',
        });
      } finally {
        this.loading = false;
      }

    },
  },
};
</script>

<style scoped>
pre {
    white-space: pre-wrap;
    word-wrap: break-word;
}
</style>
